module.exports = __webpack_public_path__ + "static/media/btn_herbs.ef40d659.png";